import { CommandPrefixes } from '../commands/practitioner/enums/CommandPrefixes';
import { MediaTypes } from '../commands/practitioner/enums/MediaTypes';
import { PlaybackType } from '../commands/practitioner/enums/PlaybackType';
import { SourceProjection } from '../commands/practitioner/enums/SourceProjection';
import { StereoMode } from '../commands/practitioner/enums/StereoMode';
import { DisplayMode } from '../commands/practitioner/enums/DisplayMode';
import { MediaStates } from '../commands/practitioner/enums/MediaStates';
import { ShowMessageCommandTypes } from '../commands/practitioner/enums/ShowMessageCommandTypes';

const {
  TOKEN,
  NOTES,
  SETTINGS_UI,
  MANUAL_COLOR,
  SUD,
  VOC,
  MEDIA_PRELOAD,
  MEDIA_PLAYBACK,
  MEDIA_VISIBILITY,
  MEDIA_LOAD_STATUS_REPORT,
  THEME_COMMAND,
  SHOW_MESSAGE_COMMAND,
} = CommandPrefixes;

export const generateEscapedTokenString = (token: string) => encodeURIComponent(`${TOKEN}\\"${token}\\"`);
export const generateEscapedTaskSettingsCommandString = (value: string) => `${SETTINGS_UI}${value}`;
export const generateNotesString = (value: string) => encodeURIComponent(`${NOTES}\\"${value}\\"`);
export const generateColorString = (value: string) => `${MANUAL_COLOR}${value}`;
export const generateThemeCommandString = (mode: boolean) => `${THEME_COMMAND}${mode ? '1' : '0'}`;
export const generateWebThemeCommandString = (mode: number) => `${THEME_COMMAND}${mode}`;
export const generateSUDString = (value: string) => `${SUD}${value}`;
export const generateVOCString = (value: string) => `${VOC}${value}`;

export const generateShowMessageCommandString = (value: ShowMessageCommandTypes) => {
  return `${SHOW_MESSAGE_COMMAND}${value}`;
};

// how to force to reload the media uri
const forceReload = 0;
/// [Visual type (Video, Image)] The starting rotation in euler angles of the media to be displayed. (0-360)
const rotation = 0;
const projection = SourceProjection.Flat;
const display = DisplayMode.Original;
const stereoMode = StereoMode.Mono;

const escapeURI = (mediaURI: string) => encodeURIComponent(`\\"${mediaURI}\\"`);

export const generateMediaLoadString = (
  mediaUri: string,
  mediaType: MediaTypes,
  projectType: SourceProjection,
  stereo: string,
  rotation: Number
) =>
  `${MEDIA_PRELOAD}${forceReload},${mediaType},${rotation},${projectType},${display},${
    stereo === 'Off' ? StereoMode.Mono : StereoMode.StereoOverUnder
  },${escapeURI(mediaUri)}`;

export const generateMediaPlaybackString = (mediaUri: string, playbackType: PlaybackType, value: number) => {
  const needsValue =
    playbackType === PlaybackType.Speed || playbackType === PlaybackType.Skip || playbackType === PlaybackType.Jump;

  if (!needsValue) {
    return `${MEDIA_PLAYBACK}${playbackType},${escapeURI(mediaUri)}`;
  }

  const normalizedValue = playbackType === PlaybackType.Speed ? value : Math.round(value);
  return `${MEDIA_PLAYBACK}${playbackType},${normalizedValue},${escapeURI(mediaUri)}`;
};

export const generateMediaVisibilityString = (mediaUri: string, isVisible: boolean) =>
  `${MEDIA_VISIBILITY}${isVisible ? 1 : 0},${escapeURI(mediaUri)}`;

export const generateMediaStatusReportString = (mediaUri: string, status: MediaStates, progress: number = 1.0) =>
  // progress is only taken into account for the device. The client will just send 100% at once.
  `${MEDIA_LOAD_STATUS_REPORT}${status},${progress},${escapeURI(mediaUri)}`;
